import { useCallback, useEffect, useRef, useState } from "react";

export interface PendingUploadFile {
  id: string;
  file: File;
  previewUrl: string;
}

export function usePendingUploadFiles() {
  const [files, setFiles] = useState<PendingUploadFile[]>([]);
  const filesRef = useRef(files);
  filesRef.current = files;

  const add = useCallback((newFiles: File[]) => {
    setFiles((current) => [
      ...current,
      ...newFiles.map((file) => ({ id: `${Date.now()}-${Math.random()}`, file, previewUrl: URL.createObjectURL(file) })),
    ]);
  }, []);

  const remove = useCallback((id: string) => {
    setFiles((current) => {
      const target = current.find((f) => f.id === id);
      if (target) URL.revokeObjectURL(target.previewUrl);
      return current.filter((f) => f.id !== id);
    });
  }, []);

  const clear = useCallback(() => {
    setFiles((current) => {
      current.forEach((f) => URL.revokeObjectURL(f.previewUrl));
      return [];
    });
  }, []);

  // Unmount cleanup only — reads filesRef (not files) so it revokes whatever is pending at unmount,
  // not just the empty array captured by this effect's initial closure.
  useEffect(() => {
    return () => {
      filesRef.current.forEach((f) => URL.revokeObjectURL(f.previewUrl));
    };
  }, []);

  return { files, add, remove, clear };
}
